export const NO_TRANSCRIPT_AVAILABLE_MESSAGE = "No transcript available";

export const DEAL_MOMENTUM_MIN_TRANSCRIPTS_MESSAGE =
  "Need minimum 2 transcripts to calculate Deal Momentum";

/** @deprecated Use {@link DEAL_MOMENTUM_MIN_TRANSCRIPTS_MESSAGE} */
export const DEAL_MOMENTUM_NO_TRANSCRIPT_MESSAGE = DEAL_MOMENTUM_MIN_TRANSCRIPTS_MESSAGE;

/** Deal momentum needs more than one call and API transcript data. */
export function hasDealMomentumTranscriptAvailable(
  hasDealMomentumData: boolean | undefined,
  callCount?: number,
): boolean {
  if (hasDealMomentumData === false) return false;
  if (callCount === undefined) return true;
  return true;
}
